import { getPmSection } from '../pm-section/actions'

export function fetchSection (sectionId) {
  return getPmSection({ sectionId })
}

export default fetchSection
